import { Button, Col, Row } from 'antd';
import FAListComponent from '../../components/financial-asset/FAListComponent';
import Title from 'antd/lib/typography/Title';
import { useEffect, useState } from 'react';
import RegisterFAModal from '../../components/financial-asset/RegisterFAModal';
import {
  createFinancialAsset,
  deleteFinancialAssets,
  getFinancialAssets,
  getMyAssetList,
  updateFinancialAsset,
} from '../../api/constlink';
import UpdateFAModal from '../../components/financial-asset/UpdateFAModal';

interface FinancialAssetContainerProps {
  enterpriseId: string;
  isMyAsset: boolean;
}

function FinancialAssetContainer({
  enterpriseId,
  isMyAsset,
}: FinancialAssetContainerProps) {
  const [visibleModal, setVisibleModal] = useState<boolean>(false);
  const [visibleEditModal, setVisibleEditModal] = useState<boolean>(false);
  const [financialAsset, setFinancialAsset] = useState<any>();
  const [editData, setEditData] = useState<any>();

  useEffect(() => {
    (async () => {
      setFinancialAsset(await getFinancialAssets(enterpriseId, isMyAsset));
    })();
  }, [enterpriseId, isMyAsset]);

  const openRegisterFAModal = () => {
    setVisibleModal(true);
  };

  const onCreate = async () => {
    console.log('onCreate');
  };

  const _createFinancialAsset = async (result: any[]) => {
    await createFinancialAsset({
      enterpriseId,
      type: isMyAsset ? 'indivisual' : 'business',
      data: [...result],
    });

    onCancel();
  };

  const onCancel = () => {
    (async () => {
      setFinancialAsset(await getFinancialAssets(enterpriseId, isMyAsset));
    })();
    setVisibleModal(false);
  };

  const openEditModal = (data: any) => {
    setEditData(data);
    setVisibleEditModal(true);
  };

  const onUpdateFA = async (data: any) => {
    await updateFinancialAsset({
      enterpriseId,
      financialAssetId: data.id,
      data: {
        ...data,
        userId: data.user.id,
      },
    });
    (async () => {
      setFinancialAsset(await getFinancialAssets(enterpriseId, isMyAsset));
    })();
    setVisibleEditModal(false);
    setEditData(null);
  };

  const onCancelFA = () => {
    setVisibleEditModal(false);
    setEditData(null);
  };

  const deleteFA = async (financialAssetId: number) => {
    await deleteFinancialAssets({
      enterpriseId,
      financialAssetId,
      type: isMyAsset ? 'indivisual' : 'business',
    });
    (async () => {
      setFinancialAsset(await getFinancialAssets(enterpriseId, isMyAsset));
    })();
  };

  const _getMyAssetList = async (data: any) => {
    const fa = await getMyAssetList({
      enterpriseId,
      data: {
        type: isMyAsset ? 'indivisual' : 'business',
        data,
      },
    });
    return fa;
  };

  return (
    <>
      <Row justify="space-between">
        <Col>
          <Title level={5}>{isMyAsset ? '내 카드' : '카드관리'}</Title>
        </Col>
        <Col>
          {!isMyAsset && (
            <Button size="small" onClick={openRegisterFAModal}>
              카드 등록
            </Button>
          )}
        </Col>
      </Row>
      {financialAsset && (
        <FAListComponent
          data={financialAsset.data}
          openEditModal={openEditModal}
          deleteFA={deleteFA}
          isMyAsset={isMyAsset}
        />
      )}
      {visibleModal && (
        <RegisterFAModal
          visible={visibleModal}
          existedFAList={financialAsset.data}
          _getMyAssetList={_getMyAssetList}
          _createFinancialAsset={_createFinancialAsset}
          onCreate={onCreate}
          onCancel={onCancel}
        />
      )}
      {visibleEditModal && editData && (
        <UpdateFAModal
          visible={visibleEditModal}
          isMyAsset={isMyAsset}
          enterpriseId={enterpriseId}
          data={editData}
          onUpdate={onUpdateFA}
          onCancel={onCancelFA}
        />
      )}
    </>
  );
}

export default FinancialAssetContainer;
